import { useWindyMapStore } from "@/stores/windy-map-store";
import { useCallback, useState } from "react";
import WeatherMenuItem from "../weather-menu-item";
import { useLocation } from "react-router-dom";

// Types
interface WindyStatusItem {
  key: string;
  label: string;
}

const WINDY_STATUS_OPTIONS: readonly WindyStatusItem[] = [
  {
    key: "temp",
    label: "Температур",
  },
  {
    key: "wind",
    label: "Салхины хурд",
  },
  {
    key: "rain",
    label: "Хур тунадас",
  },
] as const;

const WeatherMenu: React.FC = () => {
  const mapStore = useWindyMapStore((state) => state.mapStore);
  const overlay = useWindyMapStore((state) => state.overlay);
  const [isLoading, setIsLoading] = useState(false);
  const setOverlay = useWindyMapStore((state) => state.setOverlay);
  const { pathname } = useLocation();
  console.log("params", pathname);

  // Memoized click handler to prevent unnecessary re-renders
  const handleOverlayChange = useCallback(
    async (key: string) => {
      if (!mapStore || isLoading || overlay === key) return;

      try {
        setIsLoading(true);
        mapStore.set("overlay", key);
        setOverlay(key);
      } catch (error) {
        console.error("Failed to change overlay:", error);
        // Revert on error
        setOverlay(overlay);
      } finally {
        setIsLoading(false);
      }
    },
    [mapStore, overlay, isLoading]
  );

  // Loading state
  if (!mapStore) {
    return (
      <div className="flex flex-col gap-2 animate-pulse">
        {Array.from({ length: 6 }).map((_, index) => (
          <div key={index} className="h-14 bg-white/10 rounded-full" />
        ))}
      </div>
    );
  }

  return (
    <nav
      className={`flex flex-col gap-2 ${
        pathname.includes("forecast") && "hidden"
      }`}
      role="navigation"
      aria-label="Цаг агаарын харьцуулах сонголтууд"
    >
      {WINDY_STATUS_OPTIONS.map((item) => (
        <WeatherMenuItem
          key={item.key}
          item={item}
          isActive={overlay === item.key}
          onClick={handleOverlayChange}
          isDisabled={isLoading}
        />
      ))}

      {/* Optional loading indicator */}
      {isLoading && (
        <div className="absolute inset-0 bg-black/20 rounded-full flex items-center justify-center pointer-events-none">
          <div className="w-6 h-6 border-2 border-white/30 border-t-white rounded-full animate-spin" />
        </div>
      )}
    </nav>
  );
};
export default WeatherMenu;
